import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { cleanZipcode, getAddressByZipcode, isValidZipcode } from 'v2/services/viaCep';
import type { ViaCepAddress } from 'v2/services/viaCep';

const VIA_CEP_QUERY_KEY = 'viacep';

const getViaCepQueryKey = (zipcode: string) => [VIA_CEP_QUERY_KEY, cleanZipcode(zipcode)] as const;

type UseViaCepAddressOptions = Omit<UseQueryOptions<ViaCepAddress>, 'queryKey' | 'queryFn'> & {
  enabled?: boolean;
};

export function useViaCepAddress(zipcode: string, options: UseViaCepAddressOptions = {}) {
  const { enabled = false, ...queryOptions } = options;
  const cleanedZipcode = cleanZipcode(zipcode);

  return useQuery({
    queryKey: getViaCepQueryKey(cleanedZipcode),
    queryFn: () => getAddressByZipcode(cleanedZipcode),
    retry: false,
    staleTime: Infinity,
    ...queryOptions,
    enabled: enabled && isValidZipcode(cleanedZipcode)
  });
}
